<template>
  <form-field-input
    :label="label"
    v-model="filterValue"
    :help-text="helpText"
    @change="handleInput"
    type="number"
  ></form-field-input>
</template>

<script>
export default {
  name: "FilterYearBuilt",
  props: {
    label: {
      type: String,
      default: "Year Built"
    },
    helpText: String,
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].yearBuilt;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "yearBuilt",
          value
        ]);
      }
    },
    text() {
      return (this.filterValue)
        ? `Year Built: ${this.filterValue}`
        : null
    },
  },
  created() {
    this.handleInput();
  },
  methods: {
    handleInput() {
      this.$emit("change", this.text);
    },
  }
};
</script>
